export interface SearchMode {
  displayMode: string,
  pageSize: string,
  sortKey: string
}

export const initialSearchMode = {
  displayMode: 'list',
  pageSize: '20',
  sortKey: 'SCORE'
}
